import axios from 'axios';
import React,{useState,useEffect} from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TextInput } from 'evergreen-ui';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';



export default function Main() {
    

    const[coins,setCoins] = useState([]);
    const[tempcoins,setTempCoins] = useState([]);
    const[searchinput,setSearchInput]=useState("");

    useEffect(()=>{
        const f=async()=>{
            try{
                const response=await axios.get(`https://api.coingecko.com/api/v3/coins/markets?vs_currency=inr&order=market_cap_desc&per_page=250&page=1&sparkline=false`);
                setCoins(response.data);
                console.log(response.data);
            }
            catch(error)
            {
                console.log("Error :- ",error);
            }
        }
        f();
    },[]);

    const search=(searchval)=>{
        const text=searchval.toLowerCase();
        setSearchInput(text);
        const newdata=coins.filter(item=>item.name.toLowerCase().includes(text));
        if(text==="")
        {
            setTempCoins(coins);
        }
        else
        {
            setTempCoins(newdata);
        }
    }



  return (
    <div>
        <div className="input-group mb-3" style={{marginLeft:"26%",width:"50%",marginTop:"4%",height:"50px"}}>
                <input type="text" className="form-control" placeholder="Type of Search....." aria-label="Username" aria-describedby="basic-addon1" onChange={(e)=>search(e.target.value)}/>
        </div>
        <div className="tab-div">
            {
                searchinput.length===0?

                        <Card sx={{mr:"40%",boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 #eaf6f6"}} rasied={true}>
                            <CardContent>

                                    <TableContainer component={Paper} sx={{borderStyle:"solid",borderColor:"black"}}>
                                            <Table sx={{ width:"500px" }} aria-label="simple table">
                                                
                                                <TableHead>
                                                <TableRow>
                                                    <TableCell align="right">Image</TableCell>
                                                    <TableCell align="right">Name&nbsp;</TableCell>
                                                    <TableCell align="right">Current_price&nbsp;</TableCell>
                                                    <TableCell align="right">Total_valuation&nbsp;</TableCell>
                                                    <TableCell align="right">Percent_change&nbsp;</TableCell>
                                                    <TableCell align="right">Market_cap&nbsp;</TableCell>
                                                </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                {coins.map((row) => (
                                                    <TableRow
                                                    key={row.name}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                    <TableCell component="th" scope="row">
                                                        <img src={row.image} alt={row.name} style={{height:"4vh",width:"3vw"}}/>
                                                    </TableCell>
                                                    <TableCell align="right">{row.name}</TableCell>
                                                    <TableCell align="right">₹{row.current_price}</TableCell>
                                                    <TableCell align="right">{row.fully_diluted_valuation}</TableCell>
                                                    {
                                                        row.market_cap_change_percentage_24h>0?
                                                        <TableCell align="right"><span className="green">{row.market_cap_change_percentage_24h}%</span></TableCell>
                                                        :
                                                        <TableCell align="right"><span className="red">{row.market_cap_change_percentage_24h}%</span></TableCell>
                                                    }
                                                    <TableCell align="right">{row.market_cap}</TableCell>
                                                    </TableRow>
                                                ))}
                                                </TableBody>
                                            </Table>
                                    </TableContainer>

                            </CardContent>
                    </Card>
            :
            <Card sx={{mr:"40%",boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 #eaf6f6"}} rasied={true}>
                    <TableContainer component={Paper} sx={{borderStyle:"solid",borderColor:"black"}}>
                            <Table sx={{ width:"500px" }} aria-label="simple table">
                                
                                <TableHead>
                                <TableRow>
                                    <TableCell align="right">Image</TableCell>
                                    <TableCell align="right">Name&nbsp;</TableCell>
                                    <TableCell align="right">Current_price&nbsp;</TableCell>
                                    <TableCell align="right">Total_valuation&nbsp;</TableCell>
                                    <TableCell align="right">Percent_change&nbsp;</TableCell>
                                    <TableCell align="right">Market_cap&nbsp;</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {tempcoins.map((row) => (
                                    <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                    <TableCell component="th" scope="row">
                                        <img src={row.image} alt={row.name} style={{height:"4vh",width:"3vw"}}/>
                                    </TableCell>
                                    <TableCell align="right">{row.name}</TableCell>
                                    <TableCell align="right">₹{row.current_price}</TableCell>
                                    <TableCell align="right">{row.fully_diluted_valuation}</TableCell>
                                    {
                                        row.market_cap_change_percentage_24h>0?
                                        <TableCell align="right"><span className="green">{row.market_cap_change_percentage_24h}%</span></TableCell>
                                        :
                                        <TableCell align="right"><span className="red">{row.market_cap_change_percentage_24h}%</span></TableCell>
                                    }
                                    <TableCell align="right">{row.market_cap}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                    </TableContainer>

            </Card>


            }
        </div>

    </div>
  )
}
